import cn from 'classnames';

export default function Description({ description, className, prefix }) {
  return <p className={cn(`${prefix}text-skin-base ${prefix}text-sm ${prefix}truncate`, className)}>{description}</p>;
}
